import { tr } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

function useGeneratePDF(rowData, onDataLoaded) {
  const [siteInfoData, setSiteInfoData] = useState({
    ownerName: '',
    phone: '',
    email: '',
    address: '',
  });

  const [otherInfo, setOtherInfo] = useState({
    firstThinnings: '',
    secondThinnings: '',
    clearFell: '',
    treesLeftPerHectareIfDiff: '',
    noteIfYouNeedDifferentQtys: '',
    doYouRequireHardCopy: '',
    archaeologicalArea: '',
    recreationalArea: '',
    waterways: '',
    powerOrPhoneLines: '',
    railLines: '',
    nearbyDwellings: '',
    otherPleaseDetail: '',
  });

  const [timberPricingData, setTimberPricingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [siteData, setSiteData] = useState({});
  const [accountingInfo, setAccountingInfo] = useState({});

  useEffect(() => {
    if (!rowData) {
      setLoading(false);
      return;
    }

    async function fetchAll() {
      setLoading(true);

      const requests = [];
      if (rowData?.siteAssessmentID) {
        requests.push(fetchSiteInfoData());
        requests.push(getTimberPricing());
        requests.push(getSiteAssessmentData());
      }
      if (rowData?.contractUniqueID) {
        requests.push(fetchOtherDetails());
        requests.push(fetchAccountingDetails());
      }

      await Promise.all(requests);
      setLoading(false);

      if (onDataLoaded) onDataLoaded();
    }

    fetchAll();
  }, [rowData]);

  async function fetchSiteInfoData() {
    try {
      const res = await customAxios.get(`/CRM/GetContacts?id=1&crmId=${rowData?.crmID}`, { headers: authHeader() });

      console.log('SITE INFO RES =====', res);
      const crmData = res?.data?.[0];

      if (crmData) {
        setSiteInfoData({
          ownerName: crmData.crmContactFirst || '',
          phone: crmData.crmContactPhone || '',
          email: crmData.crmContactEmail || '',
          address: crmData.crmAddressLine1 || '',
        });
      }
    } catch (err) {
      console.error('Error fetching site info:', err);
    }
  }

  async function fetchOtherDetails() {
    try {
      const res = await customAxios.get(`/Ops/GetContractsQuestionnaire?contractUniqueID=${rowData?.contractUniqueID}`, {
        headers: authHeader(),
      });

      console.log('CONTRACT QUESTIONNAIRE ===', res);
      const data = res?.data?.[0];

      if (data) {
        setOtherInfo({
          firstThinnings: data.firstThinnings || '',
          secondThinnings: data.secondThinnings || '',
          clearFell: data.clearFell || '',
          treesLeftPerHectareIfDiff: data.treesLeftPerHectareIfDiff || '',
          noteIfYouNeedDifferentQtys: data.noteIfYouNeedDifferentQtys || '',
          doYouRequireHardCopy: data.doYouRequireHardCopy || '',
          archaeologicalArea: data.archaeologicalArea || '',
          recreationalArea: data.recreationalArea || '',
          waterways: data.waterways || '',
          powerOrPhoneLines: data.powerOrPhoneLines || '',
          railLines: data.railLines || '',
          nearbyDwellings: data.nearbyDwellings || '',
          otherPleaseDetail: data.otherPleaseDetail || '',
        });
      }
    } catch (err) {
      console.error('Error fetching other details:', err);
    }
  }

  async function getTimberPricing() {
    try {
      // This get all pricing version data
      // const res = await customAxios.get(`/Ops/GetTimberPricing?siteAssessmentId=${rowData?.siteAssessmentID}`, {
      //   headers: authHeader(),
      // });

      const currentPricingVersion = rowData?.pricingVersion?.match(/^\d+-\d+/)?.[0] || null;

      const res = await customAxios.get(
        `/Ops/GetTimberPricing?siteAssessmentId=${rowData?.siteAssessmentID}&pricingVersion=${currentPricingVersion}`,
        { headers: authHeader() },
      );

      const preRes = await customAxios.get(
        `/Ops/GetTimberPricing?siteAssessmentId=${rowData?.siteAssessmentID}&pricingVersion=${rowData.previousPricingVersion}`,
        { headers: authHeader() },
      );

      let uniqueData = [];

      if (res?.data && Array.isArray(res.data)) {
        const mappedData = res.data.map(item => {
          const product = (item.product ?? '')
            .toString()
            .trim()
            .toLowerCase();
          const purchasesPrice = Number(item.purchasesPrice ?? 0) || 0;
          const hectares = Number(item.hectares ?? 0) || 0;

          return {
            id: item.id,
            product: item.product ?? '',
            purchasesPrice,
            hectares,
            __dedupeKey: `${product}|${purchasesPrice}|${hectares}`,
          };
        });

        // Remove duplicates
        uniqueData = Array.from(new Map(mappedData.map(item => [item.__dedupeKey, item])).values()).map(
          ({ __dedupeKey, ...rest }) => rest,
        );

        console.log(uniqueData, 'unique');
      }

      // Store as [[uniqueData], [preRes.data]]
      setTimberPricingData([uniqueData, preRes.data]);
    } catch (err) {
      console.error('Error fetching timber pricing:', err);
    }
  }

  async function getSiteAssessmentData() {
    try {
      const res = await customAxios.get(`/CRM/GetCRMSiteDetails?siteAssessmentId=${rowData?.siteAssessmentID}`, {
        headers: authHeader(),
      });

      if (Array.isArray(res?.data) && res.data.length > 0) {
        const item = res.data[0];

        setSiteData({
          siteAssessmentID: item.siteAssessmentID,
          vatRate: item.vatRate,
        });
      }
    } catch (err) {
      console.error('Error fetching CRM site details:', err);
    }
  }

  async function fetchAccountingDetails() {
    try {
      const res = await customAxios.get(`/Ops/GetContractsAccountingInfo?contractUniqueID=${rowData?.contractUniqueID}`, {
        headers: authHeader(),
      });

      console.log('account details ===', res);
      const data = res?.data?.[0];

      console.log('data ===', data);
      setAccountingInfo(data);
    } catch (error) {
      console.log(error);
    }
  }

  return { loading, siteInfoData, siteData, otherInfo, timberPricingData, accountingInfo };
}

export default useGeneratePDF;
